/**
 * The message behind a failed apiClient call.
 *
 * useClient's validateResponse throws a plain `{ status, message }` object, not an Error.
 * So `error instanceof Error` is false for every API failure, and a catch block written
 * that way silently replaces the server's message with its own fallback — which defeats
 * the point of writing careful rejections like "\"Hero CTA\" is already on the pipeline
 * \"Q3 programme\"" and leaves the user with "please try again later".
 *
 * Checks the shape rather than the constructor, so it covers both the thrown object and a
 * genuine Error from anywhere else in the call.
 */
export const apiErrorMessage = (error: unknown, fallback = 'Please try again later'): string => {
  if (error && typeof error === 'object' && 'message' in error) {
    const { message } = error as { message?: unknown };
    if (typeof message === 'string' && message.trim()) return message.trim();
  }

  return fallback;
};
